import React from 'react';
import { Flex } from 'web-ui-kit/legacy';
import styled from 'styled-components/macro';

import { Image } from 'web-ui-kit/image';
import SuccessIconM from 'shared/icons/success-icon-monarch.svg';
import { BodyBoldLargeStyles } from 'web-ui-kit/typography';

const NotificationIcon = styled(Image)`
  margin-right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
`;
NotificationIcon.displayName = 'NotificationIcon';

const MonarchText = styled.p`
  ${BodyBoldLargeStyles}
`;

MonarchText.displayName = 'MonarchText';

export default () => {
  return (
    <Flex justify='flex-start' row style={{ alignItems: 'center' }}>
      <NotificationIcon
        src={SuccessIconM}
      />
      <MonarchText>
        Added to Cart!
      </MonarchText>
    </Flex>
  );
};
